// import { createSlice } from "@reduxjs/toolkit";

// const userSlice = createSlice({
//     name: "user",
//     initialState: {
//        userData:{}
//     },
//     reducers: {
//         setUser: (state, action) => {
//             state.userData = action.payload;
//           },
//     }
// })

// export const { setUser  } = userSlice.actions;

// export default userSlice.reducer;

// import { createSlice } from "@reduxjs/toolkit";

// const userSlice = createSlice({
//   name: "user",

//   initialState: {
//     userData: {},
//     token: null,
//     tenantId: null,
//   },

//   reducers: {
//     setUser: (state, action) => {
//       state.userData = action.payload;

//       // Adjust this depending on your actual API response
//       state.token = action.payload?.data?.data?.jwt || null;
//       state.tenantId =
//         action.payload?.data?.data?.["x-tenant-id"] || null;
//     },

//     setTenantId: (state, action) => {
//       state.tenantId = action.payload;
//     },
//   },
// });

// export const { setUser, setTenantId } = userSlice.actions;

// export default userSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",

  initialState: {
    userData: {},
    token: null,
    tenantId: null,
  },

  reducers: {
    setUser: (state, action) => {
      state.userData = action.payload;
      state.token = action.payload?.data?.data?.jwt || null;
    },

    setTenantId: (state, action) => {
      state.tenantId = action.payload;
    },

    clearUser: (state) => {
      state.userData = {};
      state.token = null;
      state.tenantId = null;
    },
  },
});

export const {
  setUser,
  setTenantId,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;